import React, { useEffect, useState, useRef } from 'react';
import { StarField } from '../components/Background/StarField';
import { SchoolWireframe } from '../components/Background/SchoolWireframe';
import { Header } from '../components/Header';
import { CardRing } from '../components/Cards/CardRing';
import { StoryTimeline } from '../components/Timeline/StoryTimeline';
import { SafetyModule } from '../components/SecondaryModule/SafetyModule';
import { ClassroomModule } from '../components/SecondaryModule/ClassroomModule';
import { GrowthModule } from '../components/SecondaryModule/GrowthModule';
import { KnowledgeModule } from '../components/SecondaryModule/KnowledgeModule';
import { AITutorModule } from '../components/SecondaryModule/AITutorModule';
import { ModuleId } from '../types/secondaryModule';
export function Dashboard() {
  const [activeIndex, setActiveIndex] = useState(2);
  const [mode, setMode] = useState<'idle' | 'active' | 'story'>('idle');
  const [activeTime, setActiveTime] = useState<string>('');
  const [openModule, setOpenModule] = useState<ModuleId | null>(null);
  const idleTimerRef = useRef<number | null>(null);
  const autoRotateTimerRef = useRef<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (containerRef.current) {
        const {
          clientX,
          clientY
        } = e;
        containerRef.current.style.setProperty('--mouse-x', `${clientX}px`);
        containerRef.current.style.setProperty('--mouse-y', `${clientY}px`);
      }
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);
  useEffect(() => {
    if (mode === 'idle' && !openModule) {
      autoRotateTimerRef.current = window.setInterval(() => {
        setActiveIndex(prev => (prev + 1) % 5);
      }, 3000);
    } else {
      if (autoRotateTimerRef.current) clearInterval(autoRotateTimerRef.current);
    }
    return () => {
      if (autoRotateTimerRef.current) clearInterval(autoRotateTimerRef.current);
    };
  }, [mode, openModule]);
  const resetIdleTimer = () => {
    setMode('active');
    setActiveTime('');
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    idleTimerRef.current = window.setTimeout(() => {
      setMode('idle');
    }, 15000);
  };
  const handleManualInteraction = () => {
    resetIdleTimer();
  };
  const handleTimeSelect = (time: string, index: number) => {
    setMode('story');
    setActiveTime(time);
    setActiveIndex(index);
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
  };
  const handleOpenModule = (moduleId: string) => {
    setOpenModule(moduleId as ModuleId);
  };
  const handleCloseModule = () => {
    setOpenModule(null);
  };
  return <div ref={containerRef} className="relative w-full h-screen bg-[#0B1120] overflow-hidden select-none" style={{
    background: `
          radial-gradient(circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(14, 165, 233, 0.08) 0%, transparent 40%),
          #0B1120
        `
  } as React.CSSProperties} onClick={handleManualInteraction} data-id="element-834">
      {/* Background Layers */}
      <StarField data-id="element-835" />
      <SchoolWireframe data-id="element-836" />

      {/* UI Layers */}
      <Header data-id="element-837" />

      <main className="relative z-10 h-full flex flex-col justify-center pb-20" data-id="element-838">
        <CardRing activeIndex={activeIndex} setActiveIndex={setActiveIndex} onManualInteraction={handleManualInteraction} onOpenModule={handleOpenModule} data-id="element-839" />
      </main>

      <StoryTimeline activeTime={activeTime} activeIndex={activeIndex} onTimeSelect={handleTimeSelect} data-id="element-840" />

      {/* Footer */}
      <div className="fixed bottom-4 left-8 text-xs text-gray-600 font-mono z-50" data-id="element-841">
        © 2025 北京交通大学附属中学
      </div>

      {/* Secondary Modules */}
      <SafetyModule moduleId="safety" isOpen={openModule === 'safety'} onClose={handleCloseModule} data-id="element-842" />
      <ClassroomModule moduleId="classroom" isOpen={openModule === 'classroom'} onClose={handleCloseModule} data-id="element-843" />
      <GrowthModule moduleId="growth" isOpen={openModule === 'growth'} onClose={handleCloseModule} data-id="element-844" />
      <KnowledgeModule moduleId="knowledge" isOpen={openModule === 'knowledge'} onClose={handleCloseModule} data-id="element-845" />
      <AITutorModule moduleId="ai-tutor" isOpen={openModule === 'ai-tutor'} onClose={handleCloseModule} data-id="element-846" />
    </div>;
}